export default {
    "locale": "pt-BR",
    "lang": "pt",
    "yes": "Sim",
    "no": "Não",
    "and": "e ",
    "or": "ou ",
    "loading": "Carregando",
    "disconnected": "Você está Offline... Tentando reconectar",
    "ok": "OK",
    "error": "Ops! Rolou uma falha crítica aqui... Mas tudo bem, logo sai uma correção ;)",
    "errorshow": "Ops! Essa expressão de rolagem está errada... Mas parabéns por tentar! Precisa de ajuda? :D",
    "genericError": "Flha Crítica! Por favor, atualize a página",
    "undefinederror": "Erro indefinido",
    "cancel": "Cancelar",
    "close": "Fechar",
    "save": "Salvar",
    "add": "Adicionar",
    "edit": "Editar",
    "delete": "Excluir",
    "send": "Enviar",
    "version": "Versão",
    "update": "atualizado em",
    "back": "Voltar",
    "datelong": "$1, $2 de $3 de $4",
    "login": {
        "email": "Email",
        "password": "Senha",
        "login": "Entrar",
        "name": "Nome",
        "color": "Cor",
        "confirm": "Confirmar senha",
        "cancel": "Cancelar",
        "create": "Criar",
        "next": "Avançar",
        "forgot": "Esqueci minha senha",
        "forgotText1": "Não se preocupe! Informe seu email e começaremos a redefinir sua senha",
        "forgotText2": "Ótimo, agora verifique seu email. Você precisa informar aqui o código fornecido no email",
        "code": "Código",
        "reset": "Redefinir",
        "newPassword": "Nova senha",
        "gotoNewProfile": "Criar novo perfil"
    },
    "profile": {
        "title": "Perfil",
        "edit": "Editar perfil",
        "save": "Salvar perfil",
        "currentpass": "Senha atual",
        "name": "Nome",
        "changepassword": "Trocar senha",
        "newpass": "Nova Senha",
        "newpassconfirm": "Confirmar Nova Senha",
        "color": "Cor do jogador",
        "logout": "Sair",
        "remove": "Excluir conta",
        "confirmremove": "Deseja realmente excluir sua conta? TODOS os seus dados seráo removidos permanentemente e não poderão ser restaurados :(",
        "noMobile": "Infelizmente, o HubRPG ainda não tem suporte a dispositivos móveis... Você precisa de uma tela de pelo menos 1280x720 pixels, um teclado, um mouse e seu navegador precisa estar no Modo Desktop",
        "noMobileNext": "Continuar mesmo assim",
        "changelog": "Ver registro de atualizações",
        "language": "Idioma da Interface"
    },
    "changelog": {
        "title": "Registro de Atualizações"
    },
    "tabs": {
        "chat": "Chat",
        "players": "Jogadores",
        "characters": "Personagens",
        "scenery": "Cenário",
        "jukebox": "Jukebox",
        "assets": "Conteúdo"
    },
    "tables": {
        "title": "Minhas Mesas",
        "create": "Criar mesa",
        "templates": "Modelos de Fichas",
        "refresh": "Atualizar lista de mesas",
        "join": "Participar",
        "waitingaccess": "Aguardando o mestre autorizar sua entrada",
        "joinaccess": "Você foi convidado para esta mesa. Deseja participar?",
        "name": "Nome",
        "code": "Código",
        "edit": "Editar jogo",
        "save": "Salvar jogo",
        "remove": "Remove jogo",
        "confirmremove": "Deseja realmente excluir este jogo? Esta ação NÃO poderá ser desfeita",
        "confirmhighlight": "Destacar a mesa consumirá de seu limite de destaques por mês. Quer destacar esta mesa?",
        "setdate": "Definir data",
        "nextgame": "Próxima partida",
        "date": "Data",
        "dateUndefined": "Data não definida",
        "cancel": "Voltar",
        "player": "Jogador(a)",
        "players": "Jogadores(as)",
        "selectedSheet": "Ficha utilizada",
        "noSheet": "Nenhuma",
        "back": "Voltar",
        "public": "Aceitando solicitações para participar?",
        "time": "Horário de inicio e fim",
        "time-value": "Das $1 até $2",
        "time-value-from": "A partir das $1",
        "time-value-to": "Até às $1",
        "time-novalue": "Horário não definido",
        "positions": "Vagas ocupadas",
        "positions-value": "$1 ocupadas de $2 disponíveis",
        "positions-value-nomax": "$1 ocupadas",
        "content": "Conteúdo",
        "tools": "Ferramentas",
        "no-tags": "Sem tags definidas",
        "manageSheet": "Gerenciar Modelos de Fichas",
        "addimage": "Selecionar",
        "thmbnail": "Imagem da Mesa",
        "breakingChanges": "Novas atualizações incríveis disponíveis! De uma olhada.",
        "knowMore": "Saiba mais",
        "dismiss": "Dispensar",
        "gotoapoiase": "Ir para APOIA.se",
        "noTable": "Você ainda não tem nenhuma mesa. Crie ou participe em alguma para jogar",
        "findtables": "Encontre mesas para jogar",
        "gototables": "Encontrar mesas",
        "hubstatus": "Acontecendo no HubRPG",
        "updateStatus": "Última atualização liberada em:",
        "viewRelease": "Ver novidades",
        "underMaintenance1": "Estamos em manutneção.",
        "underMaintenance2": "Por favor, role com paciência...",
        "twitchOnline": "Estamos em LIVE! Vem jogar com a gente",
        "nextLive": "A próxima LIVE será:",
        "goToTwitch": "Ir para Twitch",
        "thankyoupremium1": "Obrigado por ser Premium!",
        "thankyoupremium2": "Seu apoio ajuda o HubRPG",
        "notpremium1": "Você ainda não é Premium.",
        "notpremium2": "Apoie e receba benefícios",
        "goToApoiase": "Apoiar",
        "tablesCounter": "Mestre em $1 de $2 mesas disponíveis",
        "titleFriends": "Meus amigos",
        "more": "Mais opções",
        "searchplaceholder": "Buscar por pessoa",
        "searchbtn": "Buscar",
        "refreshFriends": "Atualizar lista de amigos",
        "allFriends": "Todos",
        "justFriends": "Amigos",
        "titleUserProfile": "Perfil",
        "noSytemDefined": "Sistema indefinido",
        "noContentDefined": "Conteúdo indefinido",
        "noToolsDefined": "Ferramentas indefinidas",
        "highlight": "Destacar",
        "highlightUntil": "Mesa em destaque até",
        "noNameDefined": "Nenhuma mesa em destaque",
        "noNextDefined": "Data indefinida",
        "noOwnerDefined": "Mestre infefinido",
    },
    "userprofile": {
        "addAsFriend": "Solicitar amizade",
        "acceptFriend": "Aceitar Solicitação",
        "cancelRequest": "Cancelar Solicitação",
        "unfriend": "Desfazer amizade",
        "age": "Idade",
        "ageValue": "anos",
        "gender": "Gênero",
        "genderM": "Masculino",
        "genderF": "Feminino",
        "genderB": "Não Binário",
        "city": "Cidade",
        "bio": "Bio",
        "voice": "Aceita Voice?",
        "video": "Aceita Video?",
        "stream": "Aceita Stream?",
        "pc": "Tem PC/Mac?",
        "tablet": "Tem Tablet?",
        "phone": "Tem Smartphone?",
        "contact": "Contato",
        "availability": "Disponibilidade",
        "timeRange": "das $1 às $2",
        "note": "Obs.",
        "asPlayer": "Para Jogar",
        "asGM": "Para Mestrar",
        "acceptInvites": "Aceita Convites?",
        "gameSystems": "Sistemas",
        "contentLikeable": "Conteúdo Favorável",
        "contentAvoidable": "Conteúdo Evitado",
        "tools": "Ferramentas",
        "playsIn": "Joga em",
        "playsInTables": "Mesas",
        "playsInTable": "Mesa",
        "notSpecified": "Não especificado",
        "unfriend": "Desafezer amizade",
        "block": "Bloquear",
        "unblock": "Desbloquear",
        "denounce": "Bloquear & Denunciar",
        "confirm-unfriend": "Deseja realmente desfazer a amizade com $1",
        "confirm-block": "Deseja realmente bloquear $1",
        "confirm-denounce": "Deseja realmente bloquear e denunciar $1",
        "notdefined": "Não definido",
        "addedSuccessful": "Sua solicitação de amizade foi enviada com sucesso!",
    },
    "players": {
        "gm": "Mestre/Narrador",
        "players" : "Jogadores",
        "waiting": "Aguardando aprovação",
        "update": "Atualizar",
        "allowaccess": "Permitir",
        "blockaccess": "Negar",
        "addByEmail": "Adicionar jogador ou Compartilhar código da mesa",
        "email": "Email do jogador",
        "or": "OU",
        "noParticipants": "Ainda não há parcipantes nesta mesa. Compartilhe o códio acima ou adicione pessoas pelo email",
    },
    "chat": {
        "roll" : "Rolou ",
        "leave": "saiu",
        "enter": " entrou",
        "success": " sucesso",
        "success_plural": " sucessos",
        "critical": " crítico",
        "critical_plural": " críticos",
        "fail": " falha",
        "fail_plural": " falhas",
        "welcome": "Olá!",
        "howuse": "Use este chat para enviar texto para os jogaores e narrador",
        "howroll": "Para rolar os dados, digite:",
        "istyping": "está digitando...",
        "hidden": "Rolagem oculta"
    },
    "gridtools": {
        "scenery": "Cenários",
        "sceneryname": "Nome do Cenário",
        "sceneryadd": "Adicionar",
        "sceneryedit": "Salvar",
        "sceneryactive": "Ativo",
        "sceneryactivate": "Ativar",
        "scenerygridtype": "Tipo de terreno",
        "scenerygridsquare": "Quadrados",
        "scenerygridhex": "Hexagonos",
        "scenerygridscale": "Escala do Terreno",
        "scenerygridunit": "Unidade",
        "scenerygridmeasuretype": "Tipo de dimensionamento",
        "scenerygridmeasureprecise": "Preciso",
        "scenerygridmeasurediamond": "Diamente",
        "scenerygridmeasuresquare": "Quadrado",
        "scenerygridsquarename": "q",
        "tools": "Ferramentas",
        "token": "Token",
        "square": "Retangulo",
        "circle": "Círculo",
        "ellipse": "Elipse",
        "text": "Texto",
        "blanktext": "Seu texto aqui",
        "polygon": "Polígono",
        "image": "Imagem",
        "brush": "Pincel",
        "labeldraw": "Desenho",
        "labelselection": "Seleção",
        "labelalign": "Alinhar",
        "snapcenter": "Centro",
        "snapCorner": "Canto",
        "snapAuto": "Automático",
        "snapFree": "Nenhum",
        "select": "Selecionar",
        "changelayer": "Mover para Camada",
        "bringtofront": "Trazer para frente",
        "sendtoback": "Enviar para o fundo",
        "addScenery": "Novo Cenário",
        "properties": "Propriedades",
        "imagelabel": "Imagem",
        "textlabel": "Texto",
        "colorlabel": "Cor",
        "hexlabel": "HEX #",
        "tokenlabel": "Token",
        "filterimage": "Procurar imagens",
        "managefiles": "Gerenciar arquivos",
        "layers": "Grupos",
        "layersmove": "Mover para Grupo",
        "baselayer": "Grupo Base",
        "confirmRemoveLayer": "Excluir Grupo?",
        "confirmRemoveLayerDesc": "Tem certeza que deseja excluir o grupo? Isto removerá TODOS os elementos colocados aqui",
        "confirmdelete": "Você realmente quer excluir este cenário?",
        "shareChanges": "Mostrar camada do Narrador sobre camada dos Jogadores",
        "gmmode": "Você está na Camada do Narrador, o que significa que os jogadores não verão suas modificações",
        "tabdraw": "Desenho",
        "tabscenery": "Cenários",
        "textplaceholder": "Insira seu texto aqui",
        "zoomin": "Dar Zoom",
        "zoomout": "Tirar Zoom",
        "jumpcenter": "Voltar ao Centro",
        "openmenu": "Abrir Menu",
        "gotohelp": "Obter Ajuda",
        "turnorder": "Turnos",
        "editcolor": "Editar Cor",
        "disable3dDices": "Desativar Dados 3D",
        "enable3dDices": "Ativar Dados 3D",
        "tokenOnGrid": "Presente neste Grid",
        "timers": "Temporizador"
    },
    "characters": {
        "playable": "Personagens Principais",
        "npc": "Personagens Não Jogáveis (NPCs)",
        "newChar": "Novo Personagem",
        "newNPC": "Novo NPC",
        "save": "Salvar",
        "copy": "Copiar",
        "saveandback": "Salvar e Voltar",
        "name": "Nome",
        "unamed": "Anônimo?",
        "player": "Jogador",
        "tags": "Tags",
        "filtertag": "Filtrar por tag",
        "viewmode": "Visibilidade",
        "viewlarge": "Expandida",
        "viewcompact": "Compacta",
        "ablemultiselect": "Habilitar Seleção",
        "deleteMany": "Excluir Selecionados",
        "confirmMessage1s": "Deseja realmente excluir este",
        "confirmMessage1p": "Deseja realmente excluir estes",
        "confirmMessage2s": "personagem?",
        "confirmMessage2p": "personagens?",
        "max": "Max",
        "current": "Atual",
        "visibility": "Visibilidade",
        "showValue": "Mostrar Valor e Gráfico",
        "showBar": "Mostrar apenas Gráfico",
        "showSingle": "Mostrar Valor Simples",
        "showNone": "Ocultar Ambos",
        "duplicate": "Duplicar",
        "labelsize": "Tamanho do Token",
        "labelwidth": "Largura",
        "labelheight": "Altura",
        "labelbio": "Bio e Descrição",
        "labelnotes": "Notas Gerais",
        "confirmRemove": "Deseja realmente excluir este personagem?",
        "confirmDuplicate": "Criar quantas cópias?",
        "openSheet": "Abrir ficha",
        "openOriginalSheet": "Abrir ficha Original",
        "openBio": "Bio & Notas",
        "openStatus": "Status",
        "openAbilities": "Habilidades",
        "noSheet": "Sem modelo de ficha definido para esta mesa",
        "newability": "Adicionar nova habilidade",
        "abilityname": "Nome",
        "abilitymacro": "Macro",
        "abilityvars": "Valores variáveis",
        "abilitydesc": "Descrição",
        "abilityaddnewvalue": "Adicionar novo valor variável",
        "noChars": "Nenhum persoangem disponível. Use o botão abaixo para criar um",
    },
    "jukebox": {
        "add": "Adicionar áudio",
        "name": "Nome",
        "youtube": "Link do youtube",
        "volume": "Volume",
        "player": "Player",
        "noMusic": "Sem vídeos adicionados. Escolha um vídeo do YouTube, copie o link e adicione à lista de músicas desta mesa",
    },
    "assets": {
        "newAsset": "Novo Conteúdo",
        "filtertag": "Filtrar por tag",
        "name": "Nome",
        "tags": "Tags",
        "type": "Tipo",
        "visibility": "Visibilidade",
        "visibility_0": "Privado",
        "visibility_1": "Público",
        "visibility_2": "Pessoas específicas",
        "visibleTo": "Visivel para",
        "type_0": "Texto",
        "type_1": "Imagem",
        "type_2": "Tabela",
        "title": "Conteúdo",
        "afterinsert": "Você poderá definir o conteúdo após criá-lo",
        "confirmRemove": "Quer realmente excluir este conteúdo? Isto não poderá ser desfeito",
        "openContent": "Abrir Conteúdo",
        "showToPlayers": "Exibir conteúdo",
        "hideFromPlayers": "Ocultar conteúdo",
        "defaultTextContent": "Adicione o conteúdo aqui",
        "viewerTitle": "Ver Conteúdo",
        "saveAndContinue": "Salvar e Continuar",
        "noAssets": "Sem conteúdo disponível. Aguarde o(a) mestre liberar novos conteúdos",
        "noAssetsGM": "Sem conteúdo disponível. Tente criar um usamdo o botão abaixo",
    },
    "texteditor": {
        "bold" : "Negrito",
        "italic" : "Itálico",
        "underline" : "Sublinhado",
        "h1" : "Título",
        "h2" : "Cabeçalho",
        "h3" : "Sub-cabeçalho",
        "list" : "Lista",
        "quote" : "Citação",
        "unindent" : "Reduzir indentação",
        "indent" : "Aumentar indentação"
    },
    "filemanager": {
        "title": "Gerenciador de Arquivos",
        "upload": "Adicionar",
        "cancel": "Cancelar",
        "confirmUpeload": "Confirmar",
        "filename": "Nome",
        "filetype": "Tipo",
        "size": "Tamanho",
        "remove": "Excluir selecionados",
        "confirmRemove": "Deseja realmente excluir isto?",
        "thisTable": "Esta mesa",
        "files": "Arquivos",
        "allTable": "Todas as mesas",
        "select": "Selecionar",
        "filesList": "arquivos selecionados",
        "filesList_": "arquivo selecionado",
        "status": {
            "waiting": "Salvando",
            "error": "Erro",
            "ok": "Pronto"
        }
    },
    "templatemanager" : {
        "title": "Gerenciar Modelos de Fichas",
        "titleMin": "Modelos de Fichas",
        "cancel": "Cancelar",
        "filter": "Procurar modelo",
        "create": "Criar",
        "fork": "Copiar",
        "edit": "Editar",
        "select": "Selecionar",
        "mytemplates": "Minhas Fichas",
        "othertemplates": "Outras Fichas",
        "nofilter": "Pesquise no campo acima para encontrar um modelo de ficha",
        "noresult": "Sem fichas públicas encontradas para esta busca. Mude a pequisa ou crie você mesmo seu modelo de ficha!",
        "confirmRemove": "Deseja realmente excluir este modelo?",
        "owner": "Este modelo foi criado por você",
        "editor": "Você pode editar este modelo",
        "staff": "Esta ficha tem Medalha de \"Melhor Escolha\" para este sistema de jogo",
        "nosystem": "Sem sistema",
    },
    "templatebuilder": {
        "name": "Nome do Modelo",
        "pages": "Número de Páginas",
        "isPublic": "Permitir que outras mesas usem esta ficha",
        "editableTo": "Editável Por",
        "editableJustMe": "Somente você",
        "editableOne": "outra pessoa",
        "editableMany": "outras pessoas",
        "changeEditableTo": "Alterar Editores",
        "addfield": "Adicionar Campo",
        "component_line": "Texto com rótulo",
        "component_textsolo": "Texto sem rótulo",
        "component_label": "Rótulo",
        "component_textint": "Números Inteiros",
        "component_textfloat": "Número Fracionado",
        "component_textarea": "Área de Texto",
        "component_select": "Opções",
        "component_checkbox": "Caixa de Seleção",
        "component_group": "Grupo",
        "component_image": "Imagem",
        "fieldlabel": "Nome do Campo",
        "fieldname": "Referência",
        "fielddefault": "Valor Padrão",
        "fieldoptions": "Opções",
        "isAuto": "Cálculo automático?",
        "expression": "Expressão",
        "macro": "Macro",
        "macromodctrl": "Macro modificada por tecla Ctrl",
        "image": "Imagem",
        "textalign": "Alinhamento do Texto",
        "align-left": "Esquerda",
        "align-center": "Centro",
        "align-right": "Direita",
        "textsize": "Tamanho do Texto",
        "size-small": "Pequeno",
        "size-medium": "Médio",
        "size-large": "Grande",
        "hasDetails": "O jogador pode adicionar macros/descrição",
        "commentDetail": "Enviar descrição para o chat",
        "rollDetail": "Executar Macro",
        "valueDetail": "Valor",
        "descDetail": "Descricao",
        "macroDetail": "Macro",
        "removefield": "Excluir campo",
        "xpos": "Posição X",
        "ypos": "Posição Y",
        "width": "Largura",
        "height": "Altura",
        "save": "Salvar Modelo",
        "saved": "Sem modificações para salvar",
        "editors": "Editores",
        "editorsDescription": "Você deve fornecer o email da pessoa que será editora deste modelo de ficha. Lembre-se que deve ser o email cadastrado no HubRPG.",
        "addEditorByEmail": "Email",
        "noEditors": "Este modelo ainda não tem editores. Adicione pessoas para ajudar a melhorar este modelo de ficha",
        "system": "Sistema de Jogo",
        "systemDescription": "Ao utilizar este modelo de fichas, os jogadores saberão qual sistema de jogo a mesa utiliza. Isto garante que as mesas que utilizam este modelo de fichas possam ser encontradas ao filtrar por um sistema específico.",
        "noSystema": "Sem sistema de jogo definido",
        "changeSystem": "Alterar Sistema",
    },
    "charsheet" : {
        "title" : "Ficha",
        "reset": "Restaurar",
        "addShortcut": "Adicionar Atalho",
        "removeShortcut": "Remover Atalho",
        "shortcutsheet": "Fichas",
        "export": "Exportar",
        "import": "Importar",
        "importexport": "Importar/Exportar"
    },
    "turnorder" : {
        "title": "Turnos",
        "side": "Lista",
        "add": "Adicionar",
        "save": "Salvar",
        "back": "Voltar",
        "edit": "Editar",
        "emptylist": "Sem itens",
        "name": "Nome",
        "token": "Token",
        "value": "Valor",
        "moveUp": "Mover para cima",
        "moveDown": "Mover para baixo",
        "clear": "Limpar lista",
        "orderasc": "Ordenação crescente",
        "orderdesc": "Ordenação decrescente",
        "currentTurn": "Turno atual",
        "enableappend": "Permitir jogadores adicionar turnos",
        "confirmDelete": "Deseja realmente excluir o item?"
    },
    "bugreport": {
        "title": "Informar Bug",
        "heading": "Algo deu errado?",
        "description": "Se você viu algo estranho ou algo não funcionou conforme o esperado, você pode usar este formulário para nos mostrar o que houve. Por favor, seja o mais detalhado possível. Ah, e se puder enviar print, isso pode ajudar bastante ;D",
        "response": "Logo que o problema for resolvido, enviaremos um email para você informando a solução.",
        "userdescription": "Descrição",
        "images": "Imagens",
        "success": "Sucesso! Seu relato foi recebido e em breve traremos uma correção. Obrigado!",
        "error": "Ops! Algo deu errado. Tente enviar imagens menores ou tente novamente...",
    },
    "timers": {
        "title": "Temporizadores",
        "nodata": "Nenhum temporizador criado",
        "add": "Novo Temporizador",
        "name": "Nome",
        "type": "Tipo",
        "clockTime": "Valor",
        "clockup": "Relógio",
        "clockdown": "Contagem Regressiva",
        "statestopped": "Parado",
        "staterunning": "Contando",
        "statepaused": "Pausado",
        "play": "Iniciar",
        "pause": "Pausar",
        "stop": "Encerrar",
    },
    "friends": {
        "title": "Amigos",
        "seeAll": "Ver todos",
        "noFriends1": "Nenhum amigo online",
        "noFriends2": "Quer jogar com pessoas legais?<br />Vem pro <a href='https://discord.gg/dbBhmUBEhQ'>Discord</a> do HubRPG",
        "accept": "Aceitar",
        "refuse": "Recusar",
        "pending": "Solicitações pendentes",
        "online": "Amigos online",
        "commonTables": "mesas em comum",
        "invited": "Solicitação enviada",
        "accept": "Aceitar?",
        "noFriends": "Você ainda não tem amigos adicionados",
        "noProfiles": "Nenhum perfil encontrado para esta pesquisa",
        "noBlocked": "Nenhum perfil bloqueado",
        "unknown": "Vocês ainda não são amigos",
        "blocked": "Você bloqueou esta pessoa",
        "accepted": "Solicitação de amizade ACEITA com sucesso!",
        "removed": "Solicitação de amizade NEGADA com sucesso",
        "unfriend": "Amizade desfeita com sucesso. Que pena... :(",
        "viewblocked": "Ver bloqueados",
        "blockedsuccess": "Pessoa bloqueada com sucesso. Não vai mais incomodar você",
        "unblockedsuccess": "Pessoa desbloqueada com sucesso!",
        "denoucesuccess": "Denuncia recebida com sucesso. Desculpe o rolê :(",
        "nousername": "Sem nome de usuário"
    },
    "messages": {
        "title": "Mensagens",
        "seeAll": "Ver todas",
        "noMessagesList": "Sem mensagens não lidas :)",
        "unread": "não lidas",
        "refresh": "Atualizar mensagens",
        "conversations": "Conversas",
        "conversationWith": "Conversa com",
        "noMessageFriends": "Sem amigos para enviar mensagens. Adicione alguém primeiro.",
        "noMessages": "Vocês dois ainda não trocaram mensagens. É um bom momento para começar a jogar juntos!",
        "sendPlaceholder": "Escreva sua mensagem para enviar",
        "acceptJoin": "Aceitar",
        "joinText": "Olá! Eu gostaria de participar desta mesa",
    },
    "findtables": {
        "title": "Encontrar mesas",
        "titleHighlight": "Mesas em destaque",
        "titleCommon": "Mesas públicas",
        "filter": "Filtrar mesas",
        "more": "e mais $1",
    },
    "filter": {
        "title": "Filtros",
        "name": "Nome",
        "frequency": "Frequência",
        "frequency-any": "Qualquer",
        "frequency-weekly": "Semanal",
        "frequency-fortnight": "Quinzenal",
        "frequency-monthly": "Mensal",
        "frequency-oneshot": "One Shot",
        "positions": "Vagas para",
        "positions-gm": "Mestre",
        "positions-player": "Jogador(a)",
        "positions-any": "Qualquer",
        "availability": "Disponibilidade",
        "calendar": "Agenda",
        "calendar-auto": "Minha Disponibilidade",
        "calendar-manual": "Manual",
        "calendar-none": "Qualquer",
        "calendar-subtitle": "Desta forma, o HubRPG exibirá apenas mesas que atendam a disponibilidade que você definiu no seu perfil. Lembre-se de atualizar sua disponibilidade e encontre mesas que cabem na sua rotina!",
        "days": "Dias",
        "times": "Horários",
        "times-from": "De",
        "times-to": "Até",
        "content-show": "Exibir",
        "content-hide": "Ocultar",
        "gamesystems": "Sistemas",
        "gamesystems-show": "Exibir mesas com estes sistemas",
        "gamesystems-hide": "Ocultar mesas com estes sistemas",
        "gamesystems-none": "Nenhum sistema específico",
        "gamesystems-filter": "Digite para encontrar tags de sistemas",
        "gamesystems-notfound": "Não há sistemas para esta busca. Tente outra.",
        "gamesystems-add": "Criar esta tag",
        "contentFilter": "Conteúdo",
        "contentFilter-show": "Exibir mesas com estes conteúdos",
        "contentFilter-hide": "Ocultar mesas com estes conteúdos",
        "contentFilter-none": "Nenhum conteúdo específico",
        "contentFilter-filter": "Digite para encontrar tags de conteúdos",
        "contentFilter-notfound": "Não há conteúdos para esta busca. Tente outra.",
        "contentFilter-add": "Criar esta tag",
        "contentInclude": "Conteúdo Favorável",
        "contentInclude-show": "Exibir mesas com estes conteúdos",
        "contentInclude-hide": "Ocultar mesas com estes conteúdos",
        "contentInclude-none": "Nenhum conteúdo específico",
        "contentInclude-filter": "Digite para encontrar tags de conteúdos",
        "contentInclude-notfound": "Não há conteúdos para esta busca. Tente outra.",
        "contentInclude-add": "Criar esta tag",
        "contentAvoid": "Conteúdo Evitável",
        "contentAvoid-show": "Exibir mesas com estes conteúdos",
        "contentAvoid-hide": "Ocultar mesas com estes conteúdos",
        "contentAvoid-none": "Nenhum conteúdo específico",
        "contentAvoid-filter": "Digite para encontrar tags de conteúdos",
        "contentAvoid-notfound": "Não há conteúdos para esta busca. Tente outra.",
        "contentAvoid-add": "Criar esta tag",
        "tools": "Ferramentas",
        "tools-show": "Exibir mesas com estas ferramentas",
        "tools-hide": "Ocultar mesas com estas ferramentas",
        "tools-none": "Nenhuma ferramenta específica",
        "tools-filter": "Digite para encontrar tags de ferramentas",
        "tools-notfound": "Não há ferramentas para esta busca. Tente outra.",
        "tools-add": "Criar esta tag",
        "tagInclude": "Incluir",
        "tagAvoid": "Evitar",
        "addButton": "Adicionar",
        "filterButton": "Filtrar",
        "clearButton": "Limpar",
        "filteringBy": "Você está filtrando por mesas nestes critérios: ",
        "noItemsFilter": "Não há mesas públicas com os critérios definidos. Crie uma você mesmo!",
        "noItems": "Não há mesas públicas... Crie uma agora!"
    },
    "tabledetail": {
        "title": "Detalhes da Mesa",
        "ask": "Solicitar participação",
        "more": "Mais opções",
        "denouce": "Denunciar",
        "confirm-denouce": "Deseja realmente denunciar esta mesa?",
        "next": "Próxima sessão",
        "next-none": "Data não definida",
        "frequency": "Frequência",
        "frequency-weekly": "Semanal",
        "frequency-fortnight": "Quinzenal",
        "frequency-monthly": "Mensal",
        "frequency-oneshot": "One Shot",
        "frequency-none": "Frequência não definida",
        "time": "Horário",
        "time-value": "De $1 até $2",
        "time-none": "Horário não definido",
        "positions": "Vagas",
        "positions-value": "$1 livres de $2 disponíveis",
        "positions-none": "Número de vagas não definido",
        "gamesystem": "Sistema",
        "gamesystem-none": "Sistema não definido",
        "gm": "Mestre",
        "gm-none": "Aberto para mestres",
        "content": "Conteúdo em jogo",
        "content-none": "Sem Conteúdo definido",
        "tools": "Ferramentas utilizadas",
        "tools-none": "Ferramentas não definidas",
        "players": "Participantes da mesa",
        "players-opened": "Vaga em aberto",
        "description": "Descrição",
        "description-none": "Sem descrição definida",
    },
    "tableform": {
        "title": "Criar nova mesa",
        "title-edit": "Editar mesa",
        "name": "Nome da Mesa",
        "charsheet": "Modelo de Ficha",
        "charsheet-none": "Modelo não definido",
        "choose": "Escolher",
        "image": "Imagem",
        "next": "Próxima sessão",
        "description": "Descrição",
        "frequency": "Frequência",
        "frequency-weekly": "Semanal",
        "frequency-fortnight": "Quinzenal",
        "frequency-monthly": "Mensal",
        "frequency-oneshot": "One Shot",
        "start": "Início",
        "end": "Término",
        "positions": "Vagas",
        "create": "Criar",
        "public": "Pública?",
    },
    "profileform": {
        "title": "Editar seu perfil",
        "name": "Seu nome",
        "username": "Nome de usuário",
        "email": "Email",
        "birthdate": "Nascimento",
        "age": "Idade",
        "yearsold": "anos",
        "city": "Cidade",
        "state": "Estado",
        "gender": "Gênero",
        "gender-f": "Feminino",
        "gender-m": "Masculino",
        "gender-b": "Não Binário",
        "visibility-friends": "Amigos",
        "visibility-public": "Público",
        "visibility-hide": "Oculto",
        "bio": "Bio",
        "color": "Cor do Perfil",
        "resouces": "Recursos",
        "acceptVoice": "Aceita Voice?",
        "haspc": "Tem PC/Mac?",
        "acceptVideo": "Aceita Vídeo",
        "hasTablet": "Tem Tablet?",
        "acceptStream": "Aceita Stream",
        "hasPhone": "Tem Smartphone?",
        "contacts": "Contatos",
        "whatsapp": "Whatsapp",
        "telegram": "Telegram",
        "facebook": "Facebook",
        "instagram": "Instagram",
        "twitter": "Twitter",
        "discord": "Discord",
        "asPlayer": "Jogador(a)",
        "asGM": "Mestre",
        "acceptInviteToPlay": "Aceita convites para jogar",
        "acceptInviteToGM": "Aceita conviter para mestrar",
        "availability": "Disponibilidade",
        "weekday": "Dia da Semana",
        "timestart": "Início",
        "timeend": "Término",
        "frequency": "Frequência",
        "obs": "Observações",
        "NoAvailability": "Você ainda não adicionou nenhum horário disponível para jogar",
        "language": "Idioma"
    },
    "donate": {
        "title": "Você sabia?",
        "donate": "Apoiar",
        "text1": "Uma ferramenta de qualidade e um espaço que valorize o seu RPG como ele merece!",
        "text2": "Esse é o objetivo do HubRPG. Mas para garantir ainda mais qualidade e mais poder ao nosso VTT, precisamos da sua ajuda para manter o servidor e ter espaço para novos recursos. Apoie com o que puder ❤",
        "current": "arrecadação atual por mês",
        "target": "Meta mensal",
    },
    "tutorial": {
        "title": "Boas vindas ao HubRPG",
        "titletable": "Como usar esta mesa?",
        "prev": "Anterior",
        "next": "Próxima",
        "title1": "Boas vindas ao HubRPG!",
        "text1": "O HubRPG é um sistema para jogar RPG de mesa, de forma online. A proposta é um ter um local onde um conjunto de ferramentas auxiliem mestres e jogadores a contar uma história imersiva, inclusíva e gerar ótimos momentos de diversão em conjunto.<br />Para saber mais sobre os recursos do HubRPG, acesse: <a href='https://hubrpg.com/ajuda'>Página Oficial de Ajuda</a>",
        "title2": "Crie o seu jogo",
        "text2": "Se você é mestre e vai iniciar um novo grupo, clique em \"Criar novo jogo\" e informe o nome de sua mesa. Após entrar, você pode configurar a ficha utilizada para as estatísticas dos personagens (pode procurar por fichas criadas por outros usuários ou então criar a sua própria!), definir imagens e gráficos para exibir aos jogadores, criar personagens jogáveis e não jogáveis e configurar músicas de fundo para ambientar sua mesa!",
        "title3": "Convide seus amigos",
        "text3": "Após iniciar a mesa, vá na aba \"Jogadores\" e forneça o código de sua mesa para que outros jogadores possam entrar nela. Não se esqueça de aprovar sua participação, senão não será possível o acesso!<br /><br />Você também pode convidá-los por email, bastanto informar o email de login utilizado na conta de cada pessoa. Neste caso, quem deve aprovar a inclusão na mesa será o próprio jogador.",
        "title4": "Entre em uma partida",
        "text4": "Clique em \"Participar de Jogo\" e insira o código fornecido pelo mestre da sua mesa<br />Logo após, aguarde ser aprovado a entrar. Uma vez dentro da mesa, você ja poderá participar do chat, rolar dados, ver os jogadores online, controlar seus tokens e ver o Mapa de Batalha",
        "title5": "Faça parte da comunidade",
        "text5": "Acesse nossas redes sociais, sugira melhorias e compartilhe com seus amigos! O HubRPG é feito pela comunidade e para a comunidade!",
        "title6": "Grid de Batalha",
        "text6": "A maior parte da tela fica disponível para visualização do cenário e do campo de batalha.<br /><br />As principais ferramentas do grid são:<br /><br />Arraste com <b>botão direito do mouse</b> para mover o cenário pela tela.<br /><br /><b>Alt+Clique</b> envia um sinal para todos os jogadores.<br /><br /><b>Ctrl+Scroll</b> aumenta e diminue o zoom.",
        "title7": "Chat e Rolagens de Dados",
        "text7": "Na lateral direita, a primeira aba exibe o chat da sala e as rolagens de dados. Para rolar os dados, você pode digitar o comando de rolagem \"@r\" ou então utilizar os atalhos, logo no canto inferior direito.",
        "title8": "Fichas, Personagens e Tokens",
        "text8": "Outra aba importante é o controle de personagens. Os jogadores verâo os tokens atribuidos para si, enquanto que o mestre verá todos os tokens.<br/><br/>Você pode ver a ficha do seu personagem, controlar estatísticas, descrições e habilidades (macros para rolagem automática. Para mais informações sobre criação de macro, consulte a <a href=\"https://hubrpg.com/ajuda\" target=\"_blank\">página de ajuda</a>).<br /><br />Fique atento! Cada personagem possui uma ficha e um token, tome cuidado para não inserir mais de uma vez o mesmo token no mapa. Para mestres, personagens copiados compartilham a ficha com o personagem original.",
        "title9": "Cenário e Gráficos",
        "text9": "Esta aba é exclusíva para mestres. Aqui, você poderá desenhar elementos no grid, inserir imagens e configurar diferentes cenas para exibí-las aos jogadores.<br/><br/>Você pode enviar elementos para a camada oculta e ordenar sua exibição na camada pública. Por fim, pode escolher como alinhar os elementos em tela ",
        "title10": "Jukebox",
        "text10": "Na última aba você encontrá o controle de músicas de fundo para as sessões. As músicas de fundo deve estar disponíveis no YouTube e apenas o mestre pode escolher quando começar e parar a música, enquanto que o controle de volume é pessoal e cada jogador pode deixar como achar mais confortável."
    },
    "date-mmm": {
        "0":"Jan",
        "1":"Fev",
        "2":"Mar",
        "3":"Abr",
        "4":"Mai",
        "5":"Jun",
        "6":"Jul",
        "7":"Ago",
        "8":"Set",
        "9":"Out",
        "10":"Nov",
        "11":"Dez"
    },
    "date-mm": {
        "0":"Janeiro",
        "1":"Feveveiro",
        "2":"Março",
        "3":"Abril",
        "4":"Maio",
        "5":"Junho",
        "6":"Julho",
        "7":"Agosto",
        "8":"Setembro",
        "9":"Outubro",
        "10":"Novembro",
        "11":"Dezembro"
    },
    "date-d": {
        "0":"Dom",
        "1":"Seg",
        "2":"Ter",
        "3":"Qua",
        "4":"Qui",
        "5":"Sex",
        "6":"Sáb",
    },
    "date-ddd": {
        "0":"Domingo",
        "1":"Segunda",
        "2":"Terça",
        "3":"Quarta",
        "4":"Quinta",
        "5":"Sexta",
        "6":"Sábado",
    },
    "dates-ddd": {
        "0":"Domingos",
        "1":"Segundas-feiras",
        "2":"Terças-feiras",
        "3":"Quartas-feiras",
        "4":"Quintas-feiras",
        "5":"Sextas-feiras",
        "6":"Sábados",
    },
    "frequencies": {
        "1": "semanalmente",
        "2": "quinzenalmente",
        "3": "mensalmente",
    },
    "denounces": {
        "reason": "Motivo",
        "note": "O que houve?",
        "boring": "Chateação",
        "span": "Spam",
        "content": "Conteúdo impróprio",
        "racism": "Preconceito/Recismo",
        "disrespect": "Desrespeito",
        "other": "Outro motivo",
    },
}